import { JDSMegaMenuBlockProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSMegaMenuBlockProps>
  ): React.FC<JDSMegaMenuBlockProps> =>
  (props: JDSMegaMenuBlockProps) => {
    return <Component {...props} />;
  };
